// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"624":"public","792":"main"}[chunkId] + "." + {"624":"e101a84e","792":"3377e531"}[chunkId] + ".css";
};